import React from 'react';

const Option = ({ onClick, children, selected, value, className, style }) => (
  <li
    onClick={() => onClick(value)}
    className={`dropdown-result ${selected ? 'dropdown-highlighted' : ''}`.trim()}
    style={style}
  >
    <div className={`${className || ''} dropdown-result-label`.trim()} data-value={value}>
      {children}
    </div>
  </li>
);

Option.propTypes = {
  selected: React.PropTypes.bool,
  value: React.PropTypes.string,
  className: React.PropTypes.string,
  style: React.PropTypes.object,
  children: React.PropTypes.node,
  onClick: React.PropTypes.func,
};

export default Option;



// WEBPACK FOOTER //
// ./src/components/dropdown/option.jsx